module.exports = __webpack_public_path__ + "img/chanpin.30fd9ab2.png";